import styled from "styled-components";

export const StyledDialogImage = styled.div`
  margin-bottom: 17px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  box-shadow: 0 5px 18px 0 rgb(0 0 0 / 11%);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff5757;
  svg {
    color: white;
    fill: white;
  }
`;
